<!--
 * @Author: 汪俊洪
 * @Date: 2021-08-13 09:44:39
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2021-08-16 19:31:48
 * @Description: 备件申请记录
-->
<template>
  <div>
    <el-form
      :inline="true"
      :model="dataForm"
      @keyup.enter.native="getList(1)"
      @submit.native.prevent
      style="margin-top:10px"
      label-width="100px"
    >
      <el-form-item :label="$t('product.submitTime')">
        <el-select
          v-model="dataForm.applyTimeType"
          clearable
          :placeholder="$t('common.time')"
          @change="getList"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('product.status')">
        <el-select
          @change="getList"
          v-model="dataForm.status"
          clearable
          :placeholder="$t('product.status')"
        >
          <el-option
            v-for="item in options2"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-table
      :data="dataList"
      border
      v-loading="loading"
    >
      <el-table-column
        type="index"
        width="50"
        header-align="center"
        align="center"
        :label="$t('product.id')"
      ></el-table-column>
      <el-table-column
        prop="demandCode"
        header-align="center"
        align="center"
        :label="$t('product.requisitionNo')"
        width="190"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <a href="javascript:" @click="openDetailHandle(scope.row.demandId)">{{
            scope.row.demandCode
          }}</a>
        </template>
      </el-table-column>
      <el-table-column
        prop="oldGoodsName"
        header-align="center"
        align="left"
        :label="$t('product.productName')"
      >
      </el-table-column>
      <el-table-column
        prop="safetyStockQuantity"
        header-align="center"
        align="center"
        :label="$t('product.quantity')"
        width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="applyTime"
        header-align="center"
        align="center"
        :label="$t('product.submitTime')"
        width="160"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div>{{ scope.row.applyTime }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="wishEndDate"
        header-align="center"
        align="center"
        :label="$t('product.estimatedTime')"
        width="160"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div>{{ scope.row.wishEndDate | formateDate }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        header-align="center"
        align="center"
        :label="$t('product.status')"
        width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div v-if="scope.row.status === 0">{{$t('applystatus.waiting')}}</div>
          <div v-if="scope.row.status === 1">{{$t('applystatus.confirm')}}</div>
          <div v-if="scope.row.status === 4">{{$t('applystatus.cancel')}}</div>
          <div v-if="scope.row.status === 5">{{$t('applystatus.complete')}}</div>
          <div v-if="scope.row.status === 6">{{$t('applystatus.evaluate')}}</div>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        header-align="center"
        align="center"
        width="160"
        :label="$t('handle')"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            v-if="scope.row.status === 0"
            size="small"
            @click="updateHandle(scope.row.demandId)"
            >{{$t('update')}}</el-button
          >
          <el-button
            type="text"
            v-if="scope.row.status === 0"
            size="small"
            @click="deleteHandle(scope.row.demandId)"
            >{{$t('delete')}}</el-button
          >
          <el-button
            type="text"
            size="small"
            v-if="scope.row.status === 1"
            @click="openDetailHandle(scope.row.demandId)"
            >{{$t('product.toConfirm')}}</el-button
          >
          <el-button
            type="text"
            size="small"
            v-if="scope.row.status === 4"
            @click="reApply(scope.row)"
            >{{$t('product.spareAgain')}}</el-button
          >
          <el-button
            type="text"
            size="small"
            v-if="scope.row.status === 5"
            @click="openDetailHandle(scope.row.demandId)"
            >{{$t('product.toEvaluate')}}</el-button
          >
          <el-button
            type="text"
            size="small"
            v-if="[5, 6].includes(scope.row.status)"
            @click="joinShopCart(scope.row)"
            >{{$t('product.addRequisition')}}</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper"
    >
    </el-pagination>
  </div>
</template>
<script>
import { formateDate } from '@/utils/formateDate'
export default {
  filters: {
    formateDate (val) {
      return formateDate('yyyy-MM-dd', val)
    }
  },
  data () {
    return {
      options: [
        {
          value: '1',
          label: this.$t('product.optTime1')
        },
        {
          value: '2',
          label: this.$t('product.optTime2')
        },
        {
          value: '3',
          label: this.$t('product.optTime3')
        },
        {
          value: '4',
          label: this.$t('product.optTime4')
        }
      ],
      options2: [
        {
          value: '',
          label: this.$t('product.optStatus1')
        },
        {
          value: '0',
          label: this.$t('product.optStatus2')
        },
        {
          value: '1',
          label: this.$t('product.optStatus3')
        },
        {
          value: '5',
          label: this.$t('product.optStatus4')
        }
      ],
      dataForm: {
        applyTimeType: '1', // 1近一个月2近三个月3近半年4近一年
        status: ''
      },
      loading: false,
      dataList: [],
      // 分页
      currentPage: 1, // 当前页
      totalPage: 0, // 总页数
      pageSize: 10
    }
  },
  methods: {
    // 根据领用单 加入购物车
    joinShopCart (row) {
      this.$http
        .post('/front/order/lclb/demand/addShoppingCart', {
          demandId: row.demandId
        })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.$store.dispatch(
            'setShoppingCartCount',
            this.$store.state.shoppingCartCount + 1
          )
          this.$message.success(this.$t('product.addRequisitionSuccess'))
        })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.currentPage = val
      this.getList()
    },
    getList () {
      this.loading = true
      var form = {
        page: this.currentPage,
        limit: this.pageSize,
        status: this.dataForm.status,
        applyTimeType: this.dataForm.applyTimeType,
        skuId: this.$route.query.skuId,
        spuId: this.$route.query.spuId
      }
      this.$http
        .post('/front/order/lclb/demand/listLclbDemandDetailBySkuSpuId', form)
        .then(({ data: res }) => {
          if (res.data.code === 0) {
            this.dataList = res.data.data
            this.totalPage = res.data.count
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 跳转详情
    openDetailHandle (id) {
      this.$router.push({ name: 'spareRequirementsDetail', query: { id: id, from: 'sparePartsLibraryGoodDetail' } })
    },
    // 再次申请备件
    reApply (row) {
      sessionStorage.setItem('reApply', JSON.stringify({ demandDetailVoList: [row] }))
      this.$router.push({
        name: 'spareRequirementsAdd',
        query: { reApply: 'true' }
      })
    },
    // 跳转商品详情
    sparePartsLibraryGoodDetail (item) {
      const { spuId = '', skuId = '', custspId = '' } = item
      window.open(
        `/sparePartsLibraryGoodDetail?spuId=${spuId}&skuId=${skuId}&custspId=${custspId}`,
        '_blank'
      )
    },
    updateHandle (id) {
      this.$router.push({ name: 'spareRequirementsUpdate', query: { id: id, from: 'sparePartsLibraryGoodDetail' } })
    },
    deleteHandle (id) {
      this.deleteData(id)
    },
    deleteData (id) {
      this.$confirm(`${this.$t('message.confirmDeleteRequisition')}?`, this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        this.$http
          .post(`/front/order/lclb/demand/deleteByOrdinary`, {
            demandId: id
          })
          .then(({ data: res }) => {
            if (res.code === 0) {
              this.getList()
              this.$message.success(this.$t('message.delete'))
            }
          })
          .catch(() => {})
      })
    }
  },
  created () {
    this.getList()
  }
}
</script>
